import { observer } from 'mobx-react-lite'
import { Table } from 'shared/ui/TableNew'
import { type ReviewRow } from 'entities/Review'
import { useReviewsListContext } from 'pages/reviews/context'
import { columns } from 'pages/reviews/pages/all/ui/ReviewsListTable/columns'
import { getReviewActions } from './getReviewActions'

export const ReviewsListTable = observer(() => {
  const { items, tableStore, scrollToTopTrigger, onSuccessDelete } = useReviewsListContext()

  const rows: ReviewRow[] = items.map((item) => {
    item.setActionsProps({
      actions: getReviewActions({
        item,
        onSuccessDelete: () => onSuccessDelete(item.id),
      }),
      showItems: 0,
      noVisibleActions: true,
    })
    return item
  })

  return (
    <Table
      ariaLabel={'ReviewsList'}
      pinnedColumnIds={['name']}
      store={tableStore}
      columns={columns}
      rows={rows}
      scrollToTOpTrigger={scrollToTopTrigger}
    />
  )
})
